// extracted by mini-css-extract-plugin
module.exports = {"static":"x_J","map":"x_K"};